import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Requirement Details',
      type: 'details',
      content: {
        '{}': {
          sections: {
            '@': 'requirementSections',
          },
        },
      },
    },
  },
  variables: {
    reqID: '?AST-S000-R001',
  },
  subqueries: {
    requirementSections: {
      filter: {
        '=': [
          {
            '@.': '!id',
          },
          {
            '@$': 'reqID',
          },
        ],
      },
      target: 'ent:!requirements:!requirement',
      quantity: 1,
      selection: {
        '[]': [
          {
            '{}': {
              name: 'Overview',
              fields: {
                '[]': [
                  {
                    '{}': {
                      id: 'code',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Requirement ID',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!code',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'name',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Requirement',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!name',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'type',
                      meta: {
                        '{}': {
                          dmsAttr: {
                            '{}': {
                              attributeId:
                                'attr:ent#!requirements#!requirement:!type',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!type',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'status',
                      meta: {
                        '{}': {
                          dmsAttr: {
                            '{}': {
                              attributeId:
                                'attr:ent#!requirements#!requirement:!status',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!status',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'priority',
                      meta: {
                        '{}': {
                          dmsAttr: {
                            '{}': {
                              attributeId:
                                'attr:ent#!requirements#!requirement:!priority',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!priority',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'spec',
                      meta: {
                        '{}': {
                          dmsAttr: {
                            '{}': {
                              attributeId:
                                'attr:ent#!requirements#!requirement:!spec',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!spec',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'specApproval',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Spec Approval',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        if: [
                          [
                            {
                              '!=': [
                                {
                                  '@': 'specApprovedAt',
                                },
                                null,
                              ],
                            },
                            'approved',
                          ],
                          'awaiting approval',
                        ],
                      },
                      readonly: true,
                    },
                  },
                ],
              },
              columnCount: 4,
            },
          },
          {
            '{}': {
              name: 'Description and Verification',
              fields: {
                '[]': [
                  {
                    '{}': {
                      id: 'description',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Description',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!descr',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'verify',
                      meta: {
                        '{}': {
                          dmsAttr: {
                            '{}': {
                              attributeId:
                                'attr:ent#!requirements#!requirement:!verify',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!verify',
                      },
                      readonly: true,
                    },
                  },
                ],
              },
              columnCount: 1,
            },
          },
          {
            '{}': {
              name: 'Source',
              fields: {
                '[]': [
                  {
                    '{}': {
                      id: 'file',
                      meta: {
                        '{}': {
                          dmsAttr: {
                            '{}': {
                              attributeId:
                                'attr:ent#!requirements#!requirement:!file',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!file',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'line',
                      meta: {
                        '{}': {
                          dmsAttr: {
                            '{}': {
                              attributeId:
                                'attr:ent#!requirements#!requirement:!line',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!line',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'commitSha',
                      meta: {
                        '{}': {
                          dmsAttr: {
                            '{}': {
                              attributeId:
                                'attr:ent#!requirements#!requirement:!commit_sha',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!commit_sha',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'observedAt',
                      meta: {
                        '{}': {
                          dmsAttr: {
                            '{}': {
                              attributeId:
                                'attr:ent#!requirements#!requirement:!observed_at',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!observed_at',
                      },
                      readonly: true,
                    },
                  },
                ],
              },
              columnCount: 3,
            },
          },
        ],
      },
      subqueries: {
        specApprovedAt: {
          ref: {
            attr: 'attr:ent#!requirements#!requirement:!spec',
          },
          target: 'ent:!specs:!spec',
          quantity: 1,
          selection: {
            '@': 'approvalMergedAt',
          },
          subqueries: {
            approvalMergedAt: {
              ref: {
                attr: 'attr:ent#!specs#!spec:!approval_pull_request',
              },
              target: 'ent:!pull_requests:!pull_request',
              selection: {
                '@.': '!merged_at',
              },
            },
          },
        },
      },
    },
  },
}
